export default function(ngModule) {
    ngModule.factory('ScannerType', function(BaseClass,$q, $http, Ticket, UIMessages) {

        /**
         * Constructor function
         *
         * @param {Object} attributes Initial attributes for the model
         */
        function ScannerType(attributes) {
            _.assign(this,attributes);
        }
        ScannerType.modelName = 'ScannerType';

        BaseClass.apply(ScannerType);

        ScannerType.validates({
            name: {
                required: true,
                length: {
                    max: 255
                }
            },
            username: {
                required: true,
                length: {
                    min: 6,
                    max: 255
                }
            },
            password: {
                requiredIf: {
                    requiredIf: function(value, instance) {
                        return !instance.guid;
                    }
                },
                length: {
                    min: 4,
                    max: 255
                }
            },
            restricted: {
                format: {
                    boolean: true
                }
            },
            visibility: {
                numericality: true
            },
            scan_types: {
                numericality: true
            },
            expires_at: {
                required: true,
                regex: {
                    // ISO8601 YYYY-MM-DDTHH:mm:ssZ
                    regex: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[\+\-]\d{2}:\d{2}$/
                }
            }
        });

        ScannerType.configureApi('/scanner/:guid', {
            queryAdmin: '/scanner/:status/:company',
            reinstate: '/scanner/:guid/reinstate'
        });
        ScannerType.belongsToMany(
            'Product',
            'products',
            '/scanner/:guid/product/^guid',
            [
                { type: 'query' },
                { type: 'attach' },
                { type: 'detach' }
            ]
        );

        ScannerType.belongsToMany(
            // This is a proxy relationship through products
            'Ticket',
            'tickets',
            '/scanner/:guid/ticket/^guid',
            [
                {
                    type: 'query',
                    fn: function(modelName, url, scanner) {
                        return scanner.$queryProduct()
                            .then(products => {
                                let ticketProducts = _.filter(
                                    products,
                                    p => p.isTicketProduct()
                                );
                                let promises = _.map(
                                    ticketProducts,
                                    product => Ticket.get({guid: product.description}).then(ticket => {
                                        // Event info is not added to proxy relations in the API
                                        // Do it here manually.
                                        if (!_.isUndefined(product.event_key))
                                            _.set(ticket, 'event_key', product.event_key);

                                        if (!_.isUndefined(product.event_ids))
                                            _.set(ticket, 'event_ids', product.event_ids);

                                        return ticket;
                                    })
                                );
                                return $q.all(promises);
                            });
                    }
                },
                {
                    type: 'attach',
                    fn: function(modelName, url, scanner, ticket) {
                        let alreadyAttachedProducts;
                        return ticket.$queryProduct()
                            .then(products => {
                                let ticketProduct = _.find(products, p => p.isTicketProduct(ticket.guid));
                                if(!ticketProduct){
                                    UIMessages.push('Could not attach Ticket');
                                    return $q.reject('Could not attach Ticket');
                                }
                                return scanner.$attachProduct(ticketProduct);
                            });
                        /* Temp disable the advanced logic, just attach the primary ticket product
                        return scanner.$queryProduct()
                            .then(_alreadyAttachedProducts => {
                                alreadyAttachedProducts = _alreadyAttachedProducts;
                                return ticket.$queryRequiredProducts();
                            })
                            .then(ticketProducts => {
                                ticketProducts = _.filter(
                                    ticketProducts,
                                    product => !_.find(alreadyAttachedProducts, { guid: product.guid })
                                );
                                let promises = _.map(ticketProducts, product => scanner.$attachProduct(product));
                                return $q.all(promises);
                            });
                            */
                    }
                },
                {
                    type: 'detach',
                    fn: function(modelName, url, scanner, ticket, pivot) {
                        let ticketProducts;
                        return ticket.$queryProduct()
                            .then(products => {
                                let ticketProduct = _.find(products, p => p.isTicketProduct(ticket.guid));
                                return scanner.$detachProduct(ticketProduct);
                            });
                        /* Temp disable the advanced logic, just detach the primary ticket product
                        return ticket.$queryRequiredProducts().then(products => {
                            ticketProducts = products;
                            return scanner.$queryTicket();
                        }).then(scannerTickets => {
                            let otherTickets = _.filter(scannerTickets, sTicket => sTicket.guid !== ticket.guid);
                            let promises = _.map(otherTickets, ticket => ticket.$queryProduct());
                            return $q.all(promises);
                        }).then(otherTicketsProducts => {
                            otherTicketsProducts = _.flatten(otherTicketsProducts);
                            let productsNotInOtherTickets = _.filter(ticketProducts, product => {
                                return !_.find(otherTicketsProducts, { guid: product.guid });
                            });
                            return $q.all(
                                _.map(
                                    productsNotInOtherTickets,
                                    product => scanner.$detachProduct(product)
                                )
                            );
                        });*/
                    }
                }
            ]
        );

        ScannerType.hasMany(
            'ScannerInstance',
            'instances',
            'scanner_type_guid',
            '/scanner/:guid/instance/^guid'
        );
        ScannerType.prototype.toString = function() { return this.name; };

        return ScannerType;
    });
}
